import React from 'react';

import { RadioCardInputProps } from './ResumeRadioCard';
import { RadioCardGroupProps } from './RadioCardGroup';

const RadioCardGroupContext = React.createContext<
    RadioCardInputProps & Pick<RadioCardGroupProps, 'name' | 'selectedValue' | 'variant'>
>({
    name: '',
});

export const RadioCardGroupProvider = RadioCardGroupContext.Provider;

export const useRadioCardGroupProps = () => React.useContext(RadioCardGroupContext);
